(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kampagne-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ksReady) return;
    root.dataset.ksReady = '1';
    var track = root.querySelector('[data-ks-track]');
    var slides = root.querySelectorAll('[data-ks-slide]');
    var dots = root.querySelectorAll('[data-ks-dot]');
    if (!track || slides.length < 2) return;

    var current = 0, timer = null;
    var seconds = parseInt(root.dataset.autoplay, 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fit() {
      var h = slides[current].offsetHeight;
      if (h) track.style.height = h + 'px';
    }
    function go(i) {
      current = (i + slides.length) % slides.length;
      fit();
      track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function mark() {
      var i = Math.round(track.scrollLeft / (slides[0].offsetWidth + 24));
      current = Math.max(0, Math.min(slides.length - 1, i));
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === current ? 'true' : 'false'); });
      fit();
    }
    fit();
    window.addEventListener('load', fit);
    window.addEventListener('resize', function () { track.style.height = ''; fit(); });
    root.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', fit); });
    function stop() { if (timer) clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (!seconds || reduce || (window.Shopify && Shopify.designMode)) return;
      timer = setInterval(function () { go(current + 1); }, seconds * 1000);
    }

    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    var prev = root.querySelector('[data-ks-prev]'), next = root.querySelector('[data-ks-next]');
    if (prev) prev.addEventListener('click', function () { stop(); go(current - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(current + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { stop(); go(parseInt(d.dataset.ksDot, 10)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(current - 1); }
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    track.addEventListener('touchstart', stop, { passive: true });
    document.addEventListener('shopify:block:select', function (e) {
      slides.forEach(function (s, n) { if (s === e.target || s.contains(e.target)) { stop(); go(n); } });
    });
    start();
  }
  function all() { document.querySelectorAll('[data-ks]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('#slider-banner');
  const slides = slider ? slider.querySelectorAll('.slide') : [];
  let current = 0;
  let intervalId = null;

  function scrollToSlide(idx) {
    if (slides[idx]) {
      const slide = slides[idx];
      // Only scroll the slider horizontally, not the whole page
      slider.scrollTo({
        left: slide.offsetLeft - slider.offsetLeft,
        behavior: 'smooth'
      });
    }
  }

  function startAutoScroll() {
    intervalId = setInterval(function() {
      current = (current + 1) % slides.length;
      scrollToSlide(current);
    }, 5000);
  }

  function stopAutoScroll() {
    if (intervalId) clearInterval(intervalId);
    intervalId = null;
  }

  document.getElementById('slider-left').addEventListener('click', function() {
    stopAutoScroll();
    current = (current - 1 + slides.length) % slides.length;
    scrollToSlide(current);
  });

  document.getElementById('slider-right').addEventListener('click', function() {
    stopAutoScroll();
    current = (current + 1) % slides.length;
    scrollToSlide(current);
  });

  startAutoScroll();
});

  } catch(e) { console.error(e); }
})();
})();
